<template>
  <form class="per_data_form">
    <h5 class="text-info">
      {{ t("user_subscriptions.profiles.update_password") }}
    </h5>
    <loader-vue :visible="sending_request"/>
    <div v-if="edit_mode">
      <div class="control-group">
        <label class="control-label" for="current_password">
          {{ t("user_subscriptions.profiles.current_password") }}:
        </label>
        <forms-password-input-vue ref='current_password' v-model="current_password" @keyup="clearErrors" />
      </div>
      <span class="per_data_form" id="edit_container">
        <label class="control-label" for="new_password">
          {{ t("user_subscriptions.profiles.new_password") }}:
        </label>
        <forms-password-input-vue ref='new_password' v-model="new_password" @keyup="clearErrors" />
      </span>
      <forms-messages-list-vue
        :messages= errors
      />

      <forms-messages-list-vue
        :messages= notifications
        :notification_message="true"
      />
      <button
        class="btn btn-primary btn-large accept_button"
        id="save"
        @click="trySave"
        type="button"
        :disabled="sending_request"
      >
        {{ t("components.forms.button.accept") }}
      </button>
      <button class="btn btn-secondary btn-large" id="cancel" @click="cancel">
        {{ t("components.forms.button.cancel") }}
      </button>
    </div>
    <button
      class="btn btn-primary btn-large"
      id="edit_password"
      v-else
      @click="toggleEditMode"
    >
      {{ t("components.forms.button.modify") }}
    </button>
  </form>
</template>

<script>
import mixins from "common/mixins";
import Validator from "common/Validator";
import constants from "common/constants";

export default {
  name: "user-subscription-profile-password-vue",
  components: {
    'forms-messages-list-vue': () => import(/* webpackChunkName: "[request]" */ "components/forms/MessagesList"),
    "forms-password-input-vue": () => import(/* webpackChunkName: "[request]" */ "components/forms/PasswordInput"),
    "loader-vue": () => import(/* webpackChunkName: "[request]" */ "components/Loader")
  },
  mixins: [mixins.requests, mixins.translate],
  data() {
    return {
      current_password: "",
      new_password: "",
      edit_mode: false,
      sending_request: false,
      errors: {},
      notifications: {},
      password_min_length: constants.PASSWORD_MIN_LENGTH,
      password_max_length: constants.PASSWORD_MAX_LENGTH
    };
  },

  created() {
    this.resetInputs();
  },

  methods: {
    toggleEditMode() {
      this.edit_mode = !this.edit_mode;
      this.resetInputs();
      this.clearErrors();
    },

    cancel() {
      this.toggleEditMode();
      this.clearNotifications();
    },

    trySave() {
      let validation = this.validate();

      if (!validation.success) {
        this.setErrors(validation.messages);
        return;
      }

      this.requestSave();
    },

    validate() {
      this.clearErrors();
      this.clearNotifications();

      let validator = new Validator([
        {
          fields: "password actual",
          values: this.current_password,
          validates: "filled",
        },
        {
          fields: "nuevo password",
          values: this.new_password,
          params: [constants.PASSWORD_MIN_LENGTH, constants.PASSWORD_MAX_LENGTH],
          validates: "length_between",
        },
        {
          fields: "nuevo password",
          values: this.new_password,
          validates: "no_blanks",
        },
        {
          fields: ["password actual", "nuevo password"],
          values: [this.current_password, this.new_password],
          validates: "changed",
        },
      ]).do();

      return validator;
    },

    requestSave() {
      this.sending_request=true
      this.http_put({
        url: this.url_for_user_subscriptions_profile(0),
        params: {
          current_password: this.current_password,
          new_password: this.new_password,
          field: "password",
        },
        success: (data) => {
          this.sending_request= false
          this.handleSuccessRequest(data.body);
        },
        error: () => {
          this.sending_request= false
        },
      });
    },

    handleSuccessRequest(request) {
      if (request.status == "password_invalid") {
        this.addError({
          password_invalid: this.t(
            "user_subscriptions.profiles.messages.password_invalid"
          ),
        });
        return;
      }

      this.notifySave();
      this.toggleEditMode();
    },

    clearErrors() {
      this.setErrors({});
    },

    clearNotifications() {
      this.setNotifications({});
    },

    addNotification(notification) {
      let notifications = Object.assign(notification, this.notifications);
      this.setNotifications(notifications);
    },

    addError(error) {
      let errors = Object.assign(error, this.errors);
      this.setErrors(errors);
    },

    resetInputs() {
      this.new_password = "";

      if (this.edit_mode) {
        this.current_password = "";
        return;
      }
    },

    notifySave() {
      this.addNotification({
        password_save_completed: this.t(
          "user_subscriptions.profiles.messages.password_save_completed"
        ),
      });
    },

    setErrors(errors) {
      this.errors = errors;
    },

    setNotifications(notifications) {
      this.notifications = notifications;
    },
  },
};
</script>

<style scoped>
</style>